import React from "react";

export const PrjText: React.FC = ({ children }) => {
  return <p className="prj__description">{children}</p>;
};
